<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import ProductsModuleContent from "./productsModuleContent.vue";
import { useFavoritesStore } from "../../stores/favoritesStore";
import {
  useListPathUpsell,
  useProductPageUpsell,
} from "../../composables/useUpsell";

const props = defineProps<{
  heading: string
  apiUrl: string
  listPath?: string
  userAuthenticated: string
  lazy: string
  limit: number
  useSliderForDesktop: string
  showAsColumnOnMobile: string
  productKey: string
  categoryName: string
  currentPage?: string
  allowQuickAdd: string
  teaserProductSize?: string
  teaserProductCount?: string
  showInventoryNotification?: string
}>();

const teaserProductSize = props.teaserProductSize?.toLowerCase() || "small";
const teaserProductCountMapping: Record<string, number> = { Four: 4, Six: 6 };
const teaserProductCount = teaserProductCountMapping[props.teaserProductCount || ""] ?? 4;

const favoritesStore = useFavoritesStore();
const rootElement = ref();
const { upsellModel, isLoading } = props.listPath
  ? useListPathUpsell({
      listPath: props.listPath,
      limit: props.limit,
      lazyLoad: true,
      rootElement,
    })
  : useProductPageUpsell({
      productKey: props.productKey,
      categoryName: props.categoryName,
      lazyLoad: true,
      rootElement,
    });

onMounted(() => {
  if (props.userAuthenticated) {
    favoritesStore.getFavorites();
  }
});
</script>

<template>
  <div ref="rootElement">
    <div
      class="product-list"
      v-for="(upsellItem, index) in upsellModel"
      :key="index"
    >
      <ProductsModuleContent
        v-if="upsellItem.primaryList"
        :heading="
          upsellItem.primaryList.label ??
          props.heading ??
          $t('maybeYouAlsoLike')
        "
        :search-result-recommend-list="upsellItem"
        :use-slider-for-desktop="useSliderForDesktop === 'True'"
        :show-as-column-on-mobile="showAsColumnOnMobile === 'True'"
        :user-authenticated="userAuthenticated === 'True'"
        :favorite-form-hidden="false"
        :is-loading="isLoading"
        :is-quick-add="allowQuickAdd === 'True'"
        :product-count="upsellItem.primaryList.productGroups.length"
        :use-skeleton-loaders="true"
        :hide-promotion="false"
        :hide-sizes="false"
        :hide-colors="false"
        :hide-favorites="false"
        :item-list-id="`${props.currentPage ?? 'productpage'}-${upsellItem.primaryList.algorithm}`"
        :item-list-name="`${props.currentPage ?? 'productpage'}-${upsellItem.primaryList.algorithm}`"
        :upsell-algorithm="upsellItem.primaryList.algorithm"
        :track-view-item-list="true"
        :track-select-item="true"
        :teaser-product-size="teaserProductSize"
        :teaser-product-count="teaserProductCount"
        :show-inventory-notification="showInventoryNotification === 'True'"
      />
    </div>
  </div>
</template>
